import { render, staticRenderFns } from "./AssetPicker.vue?vue&type=template&id=536d4f2a&scoped=true&"
import script from "./AssetPicker.vue?vue&type=script&lang=js&"
export * from "./AssetPicker.vue?vue&type=script&lang=js&"
import style0 from "./AssetPicker.vue?vue&type=style&index=0&id=536d4f2a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "536d4f2a",
  null
  
)

export default component.exports